import { render, staticRenderFns } from "./VerPdfControlInterno.vue?vue&type=template&id=7052d349&scoped=true"
import script from "./VerPdfControlInterno.vue?vue&type=script&lang=js"
export * from "./VerPdfControlInterno.vue?vue&type=script&lang=js"
import style0 from "./VerPdfControlInterno.vue?vue&type=style&index=0&id=7052d349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7052d349",
  null
  
)

export default component.exports